import {useCallback, useState} from 'react'

export type UseToggleParams = boolean | (() => boolean)

export type UseToggleResult = [boolean, () => void]

function useToggle(defaultValue?: boolean): UseToggleResult
function useToggle(defaultValue: () => boolean): UseToggleResult
function useToggle(defaultValue: UseToggleParams = false): UseToggleResult {
  const [enabled, setEnabled] = useState(defaultValue)
  const toggle = useCallback(() => {
    setEnabled(!enabled)
  }, [enabled])
  return [enabled, toggle]
}

export default useToggle
